import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import Avatar from 'presentations/views/components/atoms/Avatar';
import Headline from 'presentations/views/components/atoms/Headline';
import { spacing, fontSize, mediaMax } from 'presentations/views/styles';
import { gray01, gray06 } from 'presentations/views/styles/color';
import { transformImageUrl } from 'presentations/assets';
import { EventLink } from 'presentations/views/components/molecules/ListLinkButton';
import TeamUserNavigation from 'presentations/views/components/organisms/TeamUserNavigation';
import { useRouter } from 'next/router';

interface Props {
  name: string;
  profile?: string | null;
  profileImage: string | null;
  slug: string;
}

export default function Component(props: Props) {
  return (
    <Header>
      <Container>
        <UserContainer>
          <UserAvatar
            src={transformImageUrl(props.profileImage, {
              width: 56,
              height: 56,
            })}
            alt={props.name}
          />
          <NameContainer>
            <Headline variant="h1">{props.name}</Headline>
          </NameContainer>
        </UserContainer>
        {props.profile && <Profile>{props.profile}</Profile>}
      </Container>
      <TeamUserNavigation slug={props.slug} />
    </Header>
  );
}

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${gray06};
`;
const Container = styled.div`
  max-width: 960px;
  margin-top: ${spacing(64)};
  margin-bottom: ${spacing(32)};
`;
const UserContainer = styled.div`
  display: flex;
  align-items: center;
`;
const NameContainer = styled.div`
  margin-left: ${spacing(16)};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
`;
const UserAvatar = styled(Avatar)`
  width: 56px;
  height: 56px;
  ${mediaMax.tablet} {
    width: 40px;
    height: 40px;
  }
`;
const Profile = styled.div`
  color: ${gray01};
  margin-top: ${spacing(24)};
  text-align: center;
  max-width: 960px;
  white-space: pre-wrap;
  ${mediaMax.tablet} {
    padding: 0 ${spacing(12)};
  }
`;
